import {Component, Input, OnChanges} from '@angular/core';
import { EntityRef, EntityType } from 'src/app/core/settings/settings.service';

@Component({
  selector: 'display-entities',
  templateUrl: './display-entities.component.html',
  styleUrls: ['./display-entities.component.scss']
})
export class EntityDisplayComponent implements OnChanges {

  @Input()
  entities: EntityRef[] | undefined;

  companiesEntities = '';
  groupsEntities = '';
  vehiclesEntities = '';
  devicesEntities = '';

  constructor() { }

  ngOnChanges(): void {
    this.companiesEntities = this.formatEntitiesList(this.entities.filter(entity => entity.entityType === EntityType.company));
    this.groupsEntities = this.formatEntitiesList(this.entities.filter(entity => entity.entityType === EntityType.group));
    this.vehiclesEntities = this.formatEntitiesList(this.entities.filter(entity => entity.entityType === EntityType.vehicle));
    this.devicesEntities = this.formatEntitiesList(this.entities.filter(entity => entity.entityType === EntityType.device));
  }

  get haveEntities(): boolean {
    return !!this.entities?.length
  }

  formatEntitiesList(entities: EntityRef[]): string {
    return entities.map(e => e.name).join(', ');
  }
}
